import styled from 'styled-components';

import { Text, Skeleton } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

import comma from 'images/comma.png';

import * as endUserStyles from '../EndUser/styles';

export const Container = styled.main`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const HeaderInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero};
`;

export const HeaderLabel = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const Divisor = styled(endUserStyles.Divisor)`
  margin: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const DiscoveryBannerContainer = styled.div`
  background: url(${comma}) no-repeat right top, #fff;
  background-size: contain;
  display: grid;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.xlarge}px;
  margin: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.zero};
  border: 1px solid ${({ theme }) => theme.yoga.colors.tableBorder};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;

export const DiscoveryBannerTitle = styled(Text.H5)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  padding-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const DiscoveryBannerDescription = styled.p`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
`;

export const ProgramsListContainer = styled.article`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 249px);
  gap: ${({ theme }) => theme.yoga.spacing.medium}px;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;

  ${media.not.md`
    grid-template-columns: repeat(auto-fit, 100%);
  `}
`;

export const SkeletonCard = styled(Skeleton).attrs({
  width: 249,
  height: 203,
  type: 'rectangular',
})`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  background-color: ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  ${media.not.md`
    width: 100%;
  `}
`;
